import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100vw',
    height: '100vh',
    overflow: 'auto',
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '6.25rem',
  },
  warnIcon: {
    width: '2.625rem',
    height: '2.625rem',
    border: 'solid 0.1125rem #000',
    backgroundColor: theme.color.button.background_white,
    borderRadius: '50%',
    display: 'flex',
    // alignItems: "center",
    justifyContent: 'center',
    fontSize: theme.font.size26,
    color: theme.color.button.background_red,
    fontWeight: 'bold',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    margin: '0 0 1.5rem 0',
  },
  button: {
    width: '100%',
    width: '-moz-available',
    width: '-webkit-fill-available',
    margin: '0.875rem 1rem 2.25rem 1rem',
    minHeight: '3.125rem',
    backgroundColor: theme.color.button.background_red,
    color: theme.color.button.text_white,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    padding: '0.9375rem 0',
    borderRadius: '0.375rem',
    position: 'fixed',
    bottom: 0,
    border: 'none',
  },
  title1: {
    paddingTop: '4.375rem',
    fontFamily: 'inherit',
    fontSize: '1.5rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  title2: {
    // paddingTop: "4.375rem",
    fontFamily: 'inherit',
    fontSize: '1.625rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#ea1917', //"#da0f47",
  },
  titlePlain: {
    color: ' #000',
  },
  desc: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.57',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    marginTop: '1rem',
    marginBottom: '1.3125rem',
  },
});

function Intro(props) {
  const { classes, setIntroResult } = props;

  const handleButton = () => {
    setIntroResult('chatbot');
  };
  const title1 = '안녕하세요 고객님!';
  const title2 = 'LG전자 상담 챗봇';
  const title3 = '입니다.';
  const desc1 = 'LG전자 제품추천부터 문제 해결방법까지, ';
  const desc2 = '궁금한 사항을 실시간으로 도와드립니다.';
  const desc3 = '시작하기 버튼을 눌러 지금 만나보세요.';

  return (
    <>
      <div className={classes.mainBox}>
        <div className={classes.infoBox}>
          <div className={classes.title1}>{title1}</div>
          <div className={classes.title2}>
            {title2}
            <span className={classes.titlePlain}>{title3}</span>
          </div>
          <div className={classes.desc}>
            {desc1}
            <br />
            {desc2}
            <br />
            {desc3}
          </div>
          <img
            src="/image/ko_intro.webp"
            srcSet="/image/ko_intro@2x.webp 2x, /image/ko_intro@3x.webp 3x"
            className={classes.intro}
            alt="Hello"
          />
        </div>
        <button type="button" className={classes.button} onClick={handleButton}>
          챗봇 시작하기
        </button>
      </div>
    </>
  );
}
export default withStyles(styles)(Intro);
